// ============================================================
// Leave Requests API
// ============================================================

import client from './axios';

export const leaveRequestsApi = {
  // Apply for leave (Logged-in staff)
  apply: async (payload) => {
    const response = await client.post('/leave-requests/apply', payload);
    return response.data;
  },

  // Get pending leave requests for approval (Principal & Org Admin)
  getPending: async (params = {}) => {
    const response = await client.get('/leave-requests/pending', {
      params: { page: 1, page_size: 50, ...params },
    });
    return response.data;
  },

  // Approve a leave request
  approve: async (id, payload = {}) => {
    const response = await client.put(`/leave-requests/${id}/approve`, payload);
    return response.data;
  },

  // Reject a leave request
  reject: async (id, payload = {}) => {
    const response = await client.put(`/leave-requests/${id}/reject`, payload);
    return response.data;
  },

  // Get my leave requests (Logged-in staff)
  getMyLeaves: async (params = {}) => {
    const response = await client.get('/leave-requests/my', {
      params: { page: 1, page_size: 50, ...params },
    });
    return response.data;
  },

  // Get single my-leave detail with timeline
  getMyLeaveById: async (id) => {
    const response = await client.get(`/leave-requests/my/${id}`);
    return response.data;
  },

  // Cancel my leave request (only pending)
  cancelMyLeave: async (id, remarks = '') => {
    const response = await client.put(`/leave-requests/my/${id}/cancel`, null, {
      params: { remarks },
    });
    return response.data;
  },

  // Get my leave balance
  getMyBalance: async (year = new Date().getFullYear()) => {
    const response = await client.get('/leave-requests/balance', {
      params: { year },
    });
    return response.data;
  },

  // Get staff leave balance (Admin view)
  getStaffBalance: async (staffId, year = new Date().getFullYear()) => {
    const response = await client.get(`/leave-requests/balance/${staffId}`, {
      params: { year },
    });
    return response.data;
  },

  // Initialize leave balances for year
  initializeBalance: async (year = new Date().getFullYear()) => {
    const response = await client.post('/leave-requests/balance/initialize', { year });
    return response.data;
  },
};
